import { Size } from "@react-three/fiber";
import { OrthographicCamera } from "three";
import { IScreenAnchorPositionType, ITuple3 } from "../component-data-structure";
import { IScreenRelativeScaleType } from "../component-data-structure/types/screenRelative";

export const screenRelativeCameraNeedsUpdate = (
	camera: OrthographicCamera, 
	size: Size,
    screenRelativeScaleType?: IScreenRelativeScaleType
): boolean => {
	const aspectRatio = size.width / size.height;
    
    let needsUpdate = false;
    switch (screenRelativeScaleType) {
        // case 'width-relative':
        //     needsUpdate = camera.left !== -1  || 
        //         camera.right !== 1 ||
        //         camera.top !== 1 / aspectRatio ||
        //         camera.bottom !== -1 / aspectRatio || 
        //         camera.near !== 0 ||
        //         camera.far !== 10 ||
        //         camera.zoom !== 1;
        //     break;
        case 'absolute':
        case 'height-relative':
        default:
            needsUpdate = camera.left !== -aspectRatio  || 
                camera.right !== aspectRatio ||
                camera.top !== 1 ||
                camera.bottom !== -1 || 
                camera.near !== 0 ||
                camera.far !== 10 ||
                camera.zoom !== 1
            break;
    }
    return needsUpdate;
}

export const updateScreenRelativeCameraProperties = (
	camera: OrthographicCamera, 
	size: Size,
    screenRelativeScaleType?: IScreenRelativeScaleType
): void => {
	const aspectRatio = size.width / size.height;
    switch (screenRelativeScaleType) {
        // case 'width-relative':
        //     camera.left = -1;
        //     camera.right = 1;
        //     camera.top = 1/aspectRatio;
        //     camera.bottom = -1/aspectRatio;
        //     break;
        case 'absolute':
        case 'height-relative':
        default:
            camera.left = -aspectRatio;
            camera.right = aspectRatio;
            camera.top = 1;
            camera.bottom = -1;
    }
	camera.near = 0;
	camera.far = 10;
	camera.zoom = 1;
}

const getOrthoCameraFrustumForScaleType = (size: Size, screenRelativeContentScaleType?: IScreenRelativeScaleType) => {
    const aspectRatio = size.width / size.height;
    let top, bottom, left, right;

    switch (screenRelativeContentScaleType) {
        // case 'width-relative':
        //     top = 1 / aspectRatio;
        //     bottom = -1 / aspectRatio;
        //     left = -1;
        //     right = 1;
        //     break;
        case 'absolute':
        case 'height-relative':
        default:
            top = 1;
            bottom = -1;
            left = -aspectRatio;
            right = aspectRatio;
            break;
    }

    return {top, bottom, left, right};
}

export const getAnchorGroupPrositionDict = (size: Size, screenRelativeContentScaleType?: IScreenRelativeScaleType) => {
	const anchorPositionDict = {} as {[k in IScreenAnchorPositionType]: ITuple3};

    const {left, right, top, bottom} = getOrthoCameraFrustumForScaleType(size, screenRelativeContentScaleType);


	for (const key in IScreenAnchorPositionType) {
		let position: ITuple3 = [0, 0, 0];
		switch (key) {
			case IScreenAnchorPositionType.leftTop:
				position = [left, top, 0];
				break;
			case IScreenAnchorPositionType.topMiddle:
				position = [0, top, 0];
				break;
			case IScreenAnchorPositionType.rightTop:
				position = [right, top, 0];
				break;
			case IScreenAnchorPositionType.rightMiddle:
				position = [right, 0, 0];
				break;
			case IScreenAnchorPositionType.rightBottom:
				position = [right, bottom, 0];
				break;
			case IScreenAnchorPositionType.bottomMiddle:
				position = [0, bottom, 0];
				break;
			case IScreenAnchorPositionType.leftBottom:
				position = [left, bottom, 0];
				break;
			case IScreenAnchorPositionType.leftMiddle:
				position = [left, 0, 0];
				break;
			default:
				position = [0, 0, 0]
				break;
		}
		anchorPositionDict[key as keyof typeof anchorPositionDict] = position		
	}
	return anchorPositionDict;
}